import { Box, Flash, Label } from '@primer/react';
import { useMemo } from 'react';
import { useLiveCheckinDataContext } from './useLiveCheckInDataContext';
import WarningCheckInHocSinh from './WarningCheckInHocSinh';

const WarningList = () => {
    const { dangKyAnHocSinhs } = useLiveCheckinDataContext();
    const warningList = useMemo(() => {
        return dangKyAnHocSinhs.filter(x => !x.is_dang_ky_an && x.gio_diem_danh)
    }, [dangKyAnHocSinhs])
    return (
        <Box>
            <Box sx={{ fontSize: 20, fontWeight: 600, mb: 2, display: "flex" }}>
                <Box sx={{ flex: 1, color:'#cf222e' }}>BẠN CẦN ĐĂNG KÝ VÀ NỘP PHÍ BÁN TRÚ ĐỂ ĐƯỢC PHỤC VỤ</Box>
                <Box>
                    <Label variant='danger'>{warningList.length} học sinh</Label>
                </Box>
            </Box>
            {warningList.length <= 0 &&
                <Flash variant='success' sx={{ mt: 3 }}>
                    Không có học sinh nào đăng ký không ăn mà vẫn điểm danh
                </Flash>
            }
            {warningList.length > 0 &&
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)',
                        gap: 3,
                    }}
                >
                    {warningList.map(data => {
                        return (
                            <Box key={data.ts_hocsinh_id}>
                                <WarningCheckInHocSinh data={data} isInvalid={true} />
                            </Box>
                        );
                    })}
                </Box>
            }
        </Box>
    );
};

export default WarningList;